var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAir = function SvgAir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 18,
      height: 16
    },
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#834331",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M17.625 11.875s-2.25-1.5-8.25-1.5-8.25 1.5-8.25 1.5v-9.75s2.25-1.5 8.25-1.5 8.25 1.5 8.25 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#834331",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M7.125 14.875c2.25-2.25 0-4.5 0-4.5s-2.25-2.25 0-4.5M11.625 14.875c2.25-2.25 0-4.5 0-4.5s-2.25-2.25 0-4.5"
  })));
};
export default SvgAir;